// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --configuration production` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  nwhubapi: 'https://api.nw-hub.com',
  authapi: 'https://auth.nw-hub.com',
  janneApi: 'https://api.jannenw.info/v1/public',
};
